namespace Customer
{
	export class New
		extends ui.tab.TabHTMLPresentation
	{
		private m_Form: Form;
		private m_Input: BasicInputField[];
		private m_Company: Wollmilch.CompanyObject;

		public constructor( display: boolean = false, company?: Wollmilch.CompanyObject )
		{
			super();

			if ( !company )
			{
				throw new Error( 'INVALID_COMPANY_PARAMETER' );
			}

			this.m_Input		= [];
			this.m_Form			= new Form(
				{
					tag: 'div',
					orientation: 'horizontal'
				}
			);
			this.m_Company	= company;

			this.BuildForm();

			if ( display )
			{
				this.Display();
			}
		}

		public rebuild( root: JQuery|ui.base.BaseHTMLElement ): New
		{
			super.rebuild( root );

			this.Display();

			return this;
		}

		public Display() : void
		{
			this.m_Root.empty();

			this.m_Root.append( this.m_Form.getElement() );
		}

		private BuildForm(): void
		{
			const formgroup = this.m_Form.newFormGroup( [ 1 ] );

			formgroup.addItem(
				{
					input: new InputText( { name: 'CNO', value: '' } ),
					label: new InputLabel( { value: app.getMessage( 'Customer.List.Headers.CNO' ) } ),
				}
			);

			formgroup.addItem(
				{
					input: new InputText( { name: 'Surname', value: '' } ),
					label: new InputLabel( { value: app.getMessage( 'Customer.List.Headers.Name' ) } )
				}
			);

			formgroup.addItem(
				{
					input: new InputText( { name: 'Name', value: '' } ),
					label: new InputLabel( { value: app.getMessage( 'Customer.List.Headers.Vorname' ) } )
				}
			);

			this.m_Form.addButton(
				new Button(
					{
						title: 'Abbrechen',
						style: 'danger',
						classes: [ 'pull-right' ],
						on:
						{
							click: () => app.getGlobalTabControl().removeTab( this.m_Entry )
						}
					}
				)
			);

			this.m_Form.addButton(
				new Button(
					{
						title: 'Zurücksetzen',
						style: 'primary',
						classes: [ 'pull-right' ],
						on:
						{
							click: ((form: Form) => () => { const inputs = form.Inputs(); for ( const i in inputs ) { $( inputs[ i ].getElement() ).val( '' ); } } )(this.m_Form)
						}
					}
				)
			);

			this.m_Form.addButton(
				new Button(
					{
						title: 'Anlegen',
						style: 'success',
						classes: [ 'pull-right' ],
						on:
						{
							click: () =>
							{
								new Wollmilch.AJAX(
									{
										url: 'organization/new/Client',
										method: 'POST',
										on:
										{
											beforeSend: ( o: Wollmilch.IAJAXOptions ) =>
											{
												o.data = {};

												const inputs = this.m_Form.Inputs();

												for ( const i in inputs )
												{
													o.data[ inputs[ i ].Name() ] = inputs[ i ].Value();
												}
											},
											success: ( text: string ) =>
											{
												const obj = Wollmilch.jsonize( text );

												if ( !obj )
												{
													app.addNotify(
														{
															title: [ app.getSpanMessage( 'Customer.New.CLIENT.CREATE_TITLE' ) ],
															body: [ app.getSpanMessage( 'Customer.New.CLIENT.CREATE_TITLE' ) ],
															timeout: Number(app.getConfigValue("ToastTimeout"))
														}
													);

													return;
												}

												if ( obj.success && obj.data )
												{
													const customer = obj.data;
													let cno: any = '';
													new Wollmilch.AJAX(
														{
															url: "customer/new/" + this.m_Company.ID + "/" + customer.ID,
															method: 'POST',
															on:
															{
																beforeSend: ( o: Wollmilch.IAJAXOptions ) =>
																{
																	o.data = {};

																	const input = this.m_Form.Inputs();
																	for ( const i in input )
																	{
																		if ( input[ i ].Name() === 'CNO' )
																		{
																			cno = input[ i ].Value();
																			o.data[ input[ i ].Name() ] = cno;
																			break;
																		}
																	}
																},
																success: ( text: string ) =>
																{
																	const obj_ = Wollmilch.jsonize( text );

																	if ( !obj_ || !obj_.success )
																	{
																		app.addNotify(
																			{
																				title: [ app.getSpanMessage( 'Customer.New.CLIENT.CREATE_TITLE' ) ],
																				body: [ app.getSpanMessage( 'Customer.New.CLIENT.LINK_FAILED' ) ],
																				timeout: Number(app.getConfigValue("ToastTimeout")),
																				context: 'danger'
																			}
																		);

																		new Wollmilch.AJAX(
																			{
																				url: 'organization/remove/' + customer.ID,
																				method: 'DELETE'
																			}
																		).send();

																		return;
																	}

																	app.addNotify(
																		{
																			title: [ app.getSpanMessage( 'Customer.New.CLIENT.CREATE_TITLE' ) ],
																			body: [ app.getSpanMessage( 'Customer.New.CLIENT.SUCCESS' ) ],
																			timeout: Number(app.getConfigValue("ToastTimeout")),
																			context: 'success'
																		}
																	);

																	app.getGlobalTabControl().addTab(
																		customer.Surname + ':' + cno,
																		new Page(
																			this.m_Company,
																			{
																				Customer: customer,
																				CNO: cno,
																				Name: customer.Name
																			}
																		),
																		true
																	);

																	app.getGlobalTabControl().removeTab( this.m_Entry );
																}
															}
														}
													).send();
												}
											}
										}
									}
								).send();
							}
						}
					}
				)
			);
		}
	}
}
